import { styled } from '@mui/material';

export const GridW = styled('div')(({ theme }) => ({
  display: 'grid',
  marginTop: '-4px',
  gridTemplateColumns: '1fr 1fr',
  [theme.breakpoints.down('desktop')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

export const TileW = styled('div')(({ theme }) => ({
  padding: '8px 0px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',

  [theme.breakpoints.down('desktop')]: {
    maxWidth: '180px',
  },
}));

export const TileHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  svg: {
    width: '16px',
    height: '16px',
    minWidth: '16px',
  },
});

export const TileLabel = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '18px',
  color: theme.palette.primary.p080,
}));

export const TileValue = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isLink',
})<{ isLink?: boolean }>(({ isLink, theme }) => ({
  fontSize: '14px',
  lineHeight: '18px',
  color: isLink ? theme.palette.info.main : theme.palette.primary.p080,
  cursor: isLink ? 'pointer' : 'default',
  paddingLeft: '24px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',

  '& a': {
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'none',
  },
}));
